/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GenerationRecordExportFromJSON, GenerationRecordExportToJSON } from './GenerationRecordExport';
import { HistoryItemFromJSON, HistoryItemToJSON } from './HistoryItem';
import { UserInfoFromJSON, UserInfoToJSON } from './UserInfo';
import { UserPreferencesFromJSON, UserPreferencesToJSON } from './UserPreferences';
/**
 * Check if a given object implements the ExportUserDataResponse interface.
 */
export function instanceOfExportUserDataResponse(value) {
    if (!('history' in value) || value['history'] === undefined)
        return false;
    if (!('preferences' in value) || value['preferences'] === undefined)
        return false;
    if (!('user' in value) || value['user'] === undefined)
        return false;
    return true;
}
export function ExportUserDataResponseFromJSON(json) {
    return ExportUserDataResponseFromJSONTyped(json, false);
}
export function ExportUserDataResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'feedbackStats': json['feedbackStats'] == null ? undefined : json['feedbackStats'],
        'generationRecords': json['generationRecords'] == null ? undefined : (json['generationRecords'].map(GenerationRecordExportFromJSON)),
        'history': (json['history'].map(HistoryItemFromJSON)),
        'preferences': UserPreferencesFromJSON(json['preferences']),
        'purchasedGenerations': json['purchasedGenerations'] == null ? undefined : json['purchasedGenerations'],
        'user': UserInfoFromJSON(json['user']),
    };
}
export function ExportUserDataResponseToJSON(json) {
    return ExportUserDataResponseToJSONTyped(json, false);
}
export function ExportUserDataResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'feedbackStats': value['feedbackStats'],
        'generationRecords': value['generationRecords'] == null ? undefined : (value['generationRecords'].map(GenerationRecordExportToJSON)),
        'history': (value['history'].map(HistoryItemToJSON)),
        'preferences': UserPreferencesToJSON(value['preferences']),
        'purchasedGenerations': value['purchasedGenerations'],
        'user': UserInfoToJSON(value['user']),
    };
}
